<script lang="ts">
  import RadioButton from "@components/ui/RadioButton.svelte"
  import { Adjustment } from "@models/payments/Adjustment"

  type AdjustmentType = "discount" | "surcharge" | "non_refundable_surcharge" | undefined

  export let adjustment: Adjustment
  export let resetCoveredByInsurance: () => any
  export let disabled: boolean

  let adjustmentType: AdjustmentType = getAdjustmentType()

  function getAdjustmentType(): AdjustmentType {
    if (adjustment.transactionType === "debit" && adjustment.nonRefundable) return "non_refundable_surcharge"
    if (adjustment.transactionType === "debit") return "surcharge"
    if (adjustment.transactionType === "credit") return "discount"

    return undefined
  }

  $: {
    if (adjustmentType === "non_refundable_surcharge") {
      adjustment.transactionType = "debit"
      adjustment.nonRefundable = true
    }

    if (adjustmentType === "surcharge") {
      adjustment.transactionType = "debit"
      adjustment.nonRefundable = false
    }

    if (adjustmentType === "discount") {
      adjustment.transactionType = "credit"
      adjustment.nonRefundable = false
    }
  }
</script>

<RadioButton
  name="transactionType"
  bind:group={adjustmentType}
  onChange={resetCoveredByInsurance}
  {disabled}
  value="discount"
>
  <span class="font-semibold">Discount</span>
</RadioButton>
<ul class="ml-7 mb-3">
  <li>
    <span class="italic text-gray-700">Example: </span>Package includes airfare but traveler is only flying one-way, not
    round trip.
  </li>
  <li><span class="italic text-gray-700">Example:</span> Chaperones only pay 70% of the retail cost.</li>
  <li>
    <span class="italic text-gray-700">If cancelled: </span> Reduces travel protection coverage by the discount amount
  </li>
</ul>
<RadioButton
  name="transactionType"
  bind:group={adjustmentType}
  onChange={resetCoveredByInsurance}
  {disabled}
  value="surcharge"
>
  <span class="font-semibold">Surcharge (Refundable When Cancelling)</span>
</RadioButton>
<ul class="ml-7 mb-3">
  <li>
    <span class="italic text-gray-700">Example: </span> A few travelers need to pay an extra cost for a shuttle.
  </li>
  <li>
    <span class="italic text-gray-700">If cancelled: </span>Could be covered by travel protection.
  </li>
</ul>
<RadioButton
  name="transactionType"
  bind:group={adjustmentType}
  onChange={resetCoveredByInsurance}
  {disabled}
  value="non_refundable_surcharge"
>
  <span class="font-semibold mr-1">Surcharge (Non-Refundable When Cancelling)</span>
</RadioButton>
<ul class="ml-7 mb-1">
  <li>
    <span class="italic text-gray-700">Example: </span> A late fee or re-registration fee.
  </li>
  <li>
    <span class="italic text-gray-700">If cancelled: </span>Could be covered by travel protection.
  </li>
</ul>
